import { useEffect, useState } from 'react';
import useVideoContext from '../useVideoContext/useVideoContext';

type RoomStateType = 'disconnected' | 'connected' | 'reconnecting';

export default function useRoomState() {
  const { room } = useVideoContext();
  const [state, setState] = useState<RoomStateType>('disconnected');

  useEffect(() => {
    if (!room) {
      setState('disconnected');
      return;
    }

    // Immediately update state to room's current state
    setState(room.state as RoomStateType);

    const handleRoomState = () => setState(room.state as RoomStateType);

    room
      .on('disconnected', handleRoomState)
      .on('reconnecting', handleRoomState)
      .on('reconnected', handleRoomState);

    return () => {
      room
        .off('disconnected', handleRoomState)
        .off('reconnecting', handleRoomState)
        .off('reconnected', handleRoomState);
    };
  }, [room]);

  return state;
}
